import React from "react";
import CalendarMonth from "./CalendarMonth";

const schedule = [
  [],
  [],
  [],
  [],
  [],
  [],
  [
    {
      country: "america",
      description: "Trip begins with 27+ hours of traveling"
    }
  ],
  [
    {
      country: "america",
      description: "Mo' traveling, mo' scrabble"
    }
  ],
  [
    {
      country: "thailand",
      description: "Arrive in phuket"
    },
    {
      country: "thailand",
      description: "Check into Sleepy Station Hostel"
    },
    {
      country: "thailand",
      description: "Thai Massage (no sex sign)"
    }
  ],
  [
    {
      country: "thailand",
      description: "15 mile hike to Big Buddha"
    },
    {
      country: "thailand",
      description: "Check out Wat Chai Thararam Temple"
    },
    {
      country: "thailand",
      description: "Idaho man brings us to Bartending School rooftop pool party"
    },
    {
      country: "thailand",
      description:
        "Ate larvae, grasshopper, and frog at night market with new friends"
    }
  ],
  [
    {
      country: "thailand",
      description: "Ferry to Phi Phi"
    },
    {
      country: "thailand",
      description: "Rest day at beach, Bailey gets super burnt"
    },
    {
      country: "thailand",
      description: "Feet eaten by hundreds of fish"
    },
    {
      country: "thailand",
      description: "Firedancers, low-tide, and party on the beach"
    }
  ],
  [
    {
      country: "thailand",
      description: "Ferry back to Phuket"
    },
    {
      country: "vietnam",
      description: "Fly to Hanoi, Bailey loses luggage"
    },
    {
      country: "vietnam",
      description: "Eat street-food and explore the night market"
    }
  ],
  [
    {
      country: "vietnam",
      description: "Drink first vietnamese coffee"
    },
    {
      country: "vietnam",
      description: "Visit Hanoi Hilton prison where John McCain stayed"
    },
    {
      country: "vietnam",
      description: "Rest of the crew arrives (Merissa, Kristen, Dorian, Nikki)"
    },
    {
      country: "vietnam",
      description: "Allie and I buy fun hats"
    },
    {
      country: "vietnam",
      description: "Baily reunites with lost luggage"
    }
  ],
  [
    {
      country: "vietnam",
      description: "Allie and I go to Sa Pa with Friends Travel Vietnam"
    },
    {
      country: "vietnam",
      description: "Rest of crew goes to Ha Long Bay"
    },
    {
      country: "vietnam",
      description: "Explore Sa Pa town, tries egg coffee"
    },
    {
      country: "vietnam",
      description: "Eats hot pot for first time"
    },
    {
      country: "vietnam",
      description: "Black Mirror marathon"
    }
  ],
  [
    {
      country: "vietnam",
      description: "Sa Pa trekking begins"
    },
    {
      country: "vietnam",
      description:
        "Locals by us dried fish and chug beer at restaurant in Black Hmong Tribe village"
    },
    {
      country: "vietnam",
      description: "Help cook dinner in homestay"
    },
    {
      country: "vietnam",
      description: "Foot massage"
    }
  ],
  [
    {
      country: "vietnam",
      description: "Plant rice in rice-fields"
    },
    {
      country: "vietnam",
      description: "Get's royally smacked by Allie in scrabble"
    },
    {
      country: "vietnam",
      description: "Sa Pa Trekking Finishes"
    },
    {
      country: "vietnam",
      description:
        "Allie chugs three coffees back at hotel, I begin to worry about her coffee consumption"
    },
    {
      country: "vietnam",
      description: "Arrive back in Hanoi"
    }
  ],
  [
    {
      country: "vietnam",
      description: "Whole crew leaves for Ninh Binh"
    },
    {
      country: "vietnam",
      description: "Finishes book 'Shortest Way Home' by Pete Buttigieg"
    },
    {
      country: "vietnam",
      description: "Feet-paddle-boat through rice fields in Ninh Binh"
    },
    {
      country: "vietnam",
      description: "Bike to Great Wall of Vietnam"
    },
    {
      country: "vietnam",
      description: "Learn biking at night on rural dirt roads is a bad idea"
    }
  ],
  [
    {
      country: "vietnam",
      description:
        "Hiked to Bai Dinh Pagoda, this time driving to the trailhead ..."
    },
    {
      country: "america",
      description: "Grandpa passes away, books plane ticket home"
    },
    {
      country: "vietnam",
      description: "Took 14 hour overnight train to Danang to get to Hoi An"
    },
    {
      country: "vietnam",
      description:
        "Allie secures early scrabble lead, tries 'Shivun' and 'Zutoo', I win in shock comeback: 361 to 353"
    }
  ],
  [
    {
      country: "vietnam",
      description: "Arrive in Hoi An"
    },
    {
      country: "vietnam",
      description: "Beach day"
    },
    {
      country: "vietnam",
      description: "Boat ride in crazy night market"
    }
  ],
  [
    {
      country: "vietnam",
      description:
        "Goes back for another beach day, this time with OSU friends also traveling"
    },
    {
      country: "vietnam",
      description: "Meets the cutest dog on this planet"
    },
    {
      country: "vietnam",
      description:
        "Finds banana pants & shorts sneakily planted in my bag by friends"
    },
    {
      country: "america",
      description: "Flies back to the US for funeral"
    }
  ],
  [
    {
      country: "america",
      description: "Mo' flying, no scrabble"
    },
    {
      country: "america",
      description: "Finishes book 'Digital Minimalism' by Cal Newport"
    }
  ],
  [
    {
      country: "america",
      description: "Lands in Chicago"
    },
    {
      country: "america",
      description:
        "Goes to hospital to make sure travel edema from sitting down for so long isn't a blood clot (it wasn't)"
    }
  ],
  [
    {
      country: "america",
      description: "Goes to funeral near Chicago"
    },
    {
      country: "america",
      description:
        "Makes sleep-deprived speech at gravesite, including a story about my Grandpa and strip-clubs ... well received"
    },
    {
      country: "america",
      description: "Shiva day 1"
    }
  ],
  [
    {
      country: "america",
      description: "Shiva day 2"
    }
  ],
  [
    {
      country: "bali",
      description: "Flies to Bali"
    }
  ],
  [
    {
      country: "bali",
      description: "Lands in Kuta, Bali"
    },
    {
      country: "bali",
      description: "Mount Agung erupts a few miles away, nearby areas evacuated"
    },
    {
      country: "bali",
      description: "Explores Kuta beach and restaurants"
    }
  ],
  [
    {
      country: "bali",
      description: "Taxis to Ubud"
    },
    {
      country: "bali",
      description: "Visits all the local temples"
    },
    {
      country: "bali",
      description:
        "Fights off monkey in Sacred Monkey Sanctuary that reall wants my camera"
    }
  ],
  [
    {
      country: "bali",
      description:
        "Sunrise hike to Mount Batur (since Agung erupted) starts at 2am, meets German and Irish friends"
    },
    {
      country: "bali",
      description:
        "Meets Pat, the most interesting man in the world, who helps plan my next week of travel"
    },
    {
      country: "bali",
      description:
        "Meets Cas, who after 30 minutes of meeting her, decides to tag along trip Pat is planning for me"
    }
  ],
  [
    {
      country: "bali",
      description:
        "Pat and I barter for an hour to get the best deal on multi day bali driver. Turns out he's fluent in the local Bali langauge"
    },
    {
      country: "bali",
      description: "Jose joins trip. I meet him in the car as we're leaving"
    },
    {
      country: "bali",
      description:
        "Pat says he thought about being a tour guide, but likes planning organic trips like this more, nice guy"
    }
  ],
  [
    {
      country: "bali",
      description: "Hikes to and swims in Leke Leke waterfall"
    },
    {
      country: "bali",
      description: "Explores Ulun Danu Baratan temple in the rain"
    },
    {
      country: "bali",
      description:
        "Explores Git Git waterfall, but its all orange/red from mud from rainstorm"
    },
    {
      country: "bali",
      description: "Arrive in Lovina"
    }
  ],
  [
    {
      country: "bali",
      description: "Explores black beaches of Lovina"
    },
    {
      country: "bali",
      description: "Bath in Banjar Springs"
    },
    {
      country: "bali",
      description: "Hike to and swim in Banyumala waterfall, biggest in Bali"
    },
    {
      country: "bali",
      description: "Arrive in Munduk and meet Made, a local entrepeneur"
    }
  ],
];

export default function May() {
  return (
    <CalendarMonth monthName="May" startOfMonthOffset={3} schedule={schedule} />
  );
}
